<template>
  <div>
  <div class="flex items-center flex-wrap border-b-2 border-dashed border-grey-light relative mt-3 pb-3 child-hide">
      <div v-if="invalidfield" class="w-full text-red-dark rounded relative px-4 py-2" role="alert">
        <ul class="error-messages block sm:inline text-left list-reset" v-if="[12,13,14,15,20,21,23,25,28,30].includes(question.response_type)">
          <li v-if="question.response && question.response.validations && question.response.validations.length>0" v-for="(v,index) in question.response.validations" :key="index">
            <span > {{v.lineName}} </span>
            {{ v.message  }}
          </li>
        </ul>
        <ul class="error-messages block sm:inline text-left list-reset" v-else-if="question.tag == 'cin_number' && question.response_type == '10'">
          <li v-if="question.response.validations && question.response.validations.length > 0">{{question.response.validations[0]["message"]}}</li>
        </ul>
        <ul class="error-messages block sm:inline text-left list-reset" v-else>
          <li v-if="errorMessage">{{errorMessage}}</li>
        </ul>
      </div>
    
       <div class="w-full relative px-4 py-2" :class="{'lg:w-1/2 border-rr':!([12,13,14,15,20,23,25,28].includes(question.response_type)),'has-error':invalidfield,'border-bb':[12,13,14,15,20,21,23,25,28].includes(question.response_type)}">
      <sp-input
        theme="form"
        v-if="question.response_type == '1'"
        :name="'input' + question.sort_order"
        v-model="response.content"
        :value="question.response"
        :label="question.content"
        :disabled="disabled"
        :required="Boolean(question.required)"
      >
      </sp-input>
      <sp-textarea
        theme="form"
        v-model="response.content"
        v-else-if="question.response_type == '0'"
        :maxWords="question.max_count"
        :name="'input' + question.sort_order"
        :id="'input' + question.sort_order"
        :label="question.content"
        :disabled="disabled"
        :required="Boolean(question.required)"
      ></sp-textarea>

      <sp-dropzone
        theme="form"
        v-else-if="question.response_type == '2'"
        :id="'input' + question.sort_order"
        :label="question.content"
        :url="url"
        :vdropzonesuccess="dropzoneSuccess"
        :vdropzoneError="vdropzoneError"
        :vdropzone-removed-file="vdropzoneRemovedFile"
        :vdropzoneProcessing="vdropzoneProcessing"
        :response="response"
        :question="this.question.response"
        :disabled="disabled"
        :required="Boolean(question.required)"
      >
      </sp-dropzone>

      <sp-dropzone
        theme="form"
        v-else-if="question.response_type == '3'"
        :id="'input' + question.sort_order"
        :url="url"
        :label="question.content"
        :vdropzonesuccess="dropzoneSuccess"
        :vdropzoneError="vdropzoneError"
        type="0"
        acceptedFiles="application/pdf"
        :vdropzone-removed-file="vdropzoneRemovedFile"
        :vdropzoneProcessing="vdropzoneProcessing"
        :response="response"
        :question="this.question.response"
        :disabled="disabled"
        :required="Boolean(question.required)"
      >
      </sp-dropzone>

      <sp-dropzone
           theme="form"
           v-else-if="question.response_type == '16'"
           :id="'input' + question.sort_order"
           :url="url"
           :label="question.content"
           :vdropzonesuccess="dropzoneSuccess"
           :vdropzoneError="vdropzoneError"
           type="0"
           acceptedFiles="xlsx,xlsm,xltx,xltm,xls,xlt,xla,xlsx,csv,text/csv,application/vnd.ms-excel,application/vnd.ms-excel,application/msexcel,application/x-msexcel,application/x-excel,application/x-dos_ms_excel,application/xls,application/x-xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/plain,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
           :vdropzone-removed-file="vdropzoneRemovedFile"
           :vdropzoneProcessing="vdropzoneProcessing"
           :response="response"
           :question="this.question.response"
           :disabled="disabled"
           :required="Boolean(question.required)"
           :isExcel="true"
      >
      </sp-dropzone>
      <sp-url
        theme="form"
        :url="response.content"
        @update="onYoutubeUpdate"
        v-else-if="question.response_type == '4'"
        :label="question.content"
        :disabled="disabled"
        :required="Boolean(question.required)"
      ></sp-url>

      <sp-youtube
        theme="form"
        :url="response.content"
        @update="onYoutubeUpdate"
        v-else-if="question.response_type == '5'"
        :label="question.content"
        :disabled="disabled"
        :required="Boolean(question.required)"
      ></sp-youtube>

      <div v-else-if="question.response_type == '6'">
        <div class="block mb-4 text-blue text-2sm mb-4">
          <span v-html="question.content"></span>
          <span v-if="Boolean(question.required)" class="obligatoire"> *</span>
        </div>
        <sp-radio
          theme="form"
          v-model="response.content"
          v-for="(op,index) in question.option"
          :key="index"
          :name="'input' + question.sort_order"
          :id="'input' + question.sort_order + index"
          :value="op.value"
          :disabled="disabled"
          :readonly="disabled"
          >{{ op.name }}</sp-radio
        >
      </div>
      <div v-else-if="question.response_type == '7'">
        <div class="block mb-4 text-blue text-2sm mb-4">
          <span v-html="question.content"></span>
          <span v-if="Boolean(question.required)" class="obligatoire"> *</span>
        </div>
        <sp-checkbox
          theme="form"
          v-for="(op, index) in question.option"
          :modelValue="response.content"
          :key="index"
          :name="'input' + question.sort_order"
          :id="'input' + question.sort_order + index"
          :value="op.value"
          :disabled="disabled"
          :readonly="disabled"
          >{{ op.name }}</sp-checkbox
        >
      </div>

      <div v-else-if="question.response_type == '8'">
        <div class="block mb-4 text-blue text-2sm mb-4">
            <span v-html="question.content"></span>
            <span v-if="Boolean(question.required)" class="obligatoire"> *</span>
        </div>
      
        <flat-picker 
        v-model="response.content"
        :config="{ dateFormat: 'Y-m-d' }"
        :disabled="disabled"
        class="border border-grey rounded w-full mb-5 p-3 text-grey-darker leading focus:outline-none focus:bg-white border border-blue-light2 focus:border-blue-light focus:shadow-sm rounded text-grey-darker leading-tight"
        >
        </flat-picker>
      </div>
      <sp-input theme="form" v-if="question.response_type == '32'" 
        type="text" :required="Boolean(question.required)"  
        :name="'input' + question.sort_order" v-model="response.content"
        :value="question.response" :label="question.content" :disabled="disabled">
      </sp-input>
      <sp-input theme="form" v-if="question.response_type == '10'" type="number" :required="Boolean(question.required)" :max="question.max_count" :name="'input' + question.sort_order" v-model="response.content" :value="question.response" :label="question.content" :disabled="disabled">
      </sp-input>
      
      <div v-else-if="question.response_type == '11'">
        <div class="block mb-4 text-blue text-2sm mb-4">
          <span v-html="question.content"></span>
          <span v-if="Boolean(question.required)" class="obligatoire"> *</span>
        </div>
        <div v-if="requestForm">          
          <sp-select theme="form"  v-model="response.content"  :options="question.option" :name="'input' + question.sort_order" :id="'input' + question.sort_order + index" placeholder="Sélectionnez option"></sp-select>
        </div>
        <div v-else>
          <sp-select theme="form"  v-model="response.content" :selected="question.response.content" :options="question.option" :name="'input' + question.sort_order" :id="'input' + question.sort_order + index" placeholder="Sélectionnez option"></sp-select>
        </div>
      </div>
      <div v-if="requestForm">
        <sp-table v-if="question.response_type == '12'" type="1" v-model="response.content" :label="question.content" :required="Boolean(question.required)" theme="form" :disabled="disabled"></sp-table>
        <sp-table v-else-if="question.response_type == '13'" type="2" v-model="response.content" :label="question.content" :required="Boolean(question.required)" theme="form" :disabled="disabled"></sp-table>
        <sp-table v-else-if="question.response_type == '14'" type="3" v-model="response.content" :label="question.content" :required="Boolean(question.required)" theme="form" :disabled="disabled"></sp-table>
        <sp-table v-else-if="question.response_type == '15'" type="4" v-model="response.content" :label="question.content" :required="Boolean(question.required)" theme="form" :disabled="disabled"></sp-table>
        <sp-table v-else-if="question.response_type == '20'" type="6" v-model="response.content" :label="question.content" :required="Boolean(question.required)" theme="form" :disabled="disabled"></sp-table>
        <sp-table v-else-if="question.response_type == '21'" type="7" v-model="response.content" :label="question.content" :required="Boolean(question.required)" theme="form" :disabled="disabled"></sp-table>
        <sp-table v-else-if="question.response_type == '22'" type="8" v-model="response.content" :label="question.content" :required="Boolean(question.required)" theme="form" :disabled="disabled"></sp-table>
        <sp-table v-else-if="question.response_type == '23'" type="9" v-model="response.content" :label="question.content" :required="Boolean(question.required)" theme="form" :disabled="disabled"></sp-table>
        <sp-table v-else-if="question.response_type == '25'" type="11" v-model="response.content" :label="question.content" :required="Boolean(question.required)" theme="form" :disabled="disabled"></sp-table>
        <sp-table v-else-if="question.response_type == '28'" type="14" v-model="response.content" :label="question.content" :required="Boolean(question.required)" theme="form" :disabled="disabled"></sp-table>
        <sp-table v-else-if="question.response_type == '33'" type="17" v-model="response.content" :label="question.content" :required="Boolean(question.required)" theme="form" :disabled="disabled"></sp-table>
        <sp-table v-else-if="question.response_type == '34'" type="18" v-model="response.content" :label="question.content" :required="Boolean(question.required)" theme="form" :disabled="disabled"></sp-table>

      </div>
      <div v-else>
        <sp-table v-if="question.response_type == '12'" type="1" v-model="response.content" :selected="question.response.content" :label="question.content" :required="Boolean(question.required)" theme="form" :disabled="disabled"></sp-table>
        <sp-table v-else-if="question.response_type == '13'" type="2" v-model="response.content" :selected="question.response.content" :label="question.content" :required="Boolean(question.required)" theme="form" :disabled="disabled"></sp-table>
        <sp-table v-else-if="question.response_type == '14'" type="3" v-model="response.content" :selected="question.response.content" :label="question.content" :required="Boolean(question.required)" theme="form" :disabled="disabled"></sp-table>
        <sp-table v-else-if="question.response_type == '15'" type="4" v-model="response.content" :selected="question.response.content" :label="question.content" :required="Boolean(question.required)" theme="form" :disabled="disabled"></sp-table>
        <sp-table v-else-if="question.response_type == '20'" type="6" v-model="response.content" :selected="question.response.content" :label="question.content" :required="Boolean(question.required)" theme="form" :disabled="disabled"></sp-table>
        <sp-table v-else-if="question.response_type == '21'" type="7" v-model="response.content" :selected="question.response.content" :label="question.content" :required="Boolean(question.required)" theme="form" :disabled="disabled"></sp-table>
        <sp-table v-else-if="question.response_type == '22'" type="8" v-model="response.content" :selected="question.response.content" :label="question.content" :required="Boolean(question.required)" theme="form" :disabled="disabled"></sp-table>
        <sp-table v-else-if="question.response_type == '23'" type="9" v-model="response.content" :selected="question.response.content" :label="question.content" :required="Boolean(question.required)" theme="form" :disabled="disabled"></sp-table>
        <sp-table v-else-if="question.response_type == '25'" type="11" v-model="response.content" :selected="question.response.content" :label="question.content" :required="Boolean(question.required)" theme="form" :disabled="disabled"></sp-table>
        <sp-table v-else-if="question.response_type == '28'" type="14" v-model="response.content" :selected="question.response.content" :label="question.content" :required="Boolean(question.required)" theme="form" :disabled="disabled"></sp-table>
        <sp-table v-else-if="question.response_type == '33'" type="17" v-model="response.content" :selected="question.response.content" :label="question.content" :required="Boolean(question.required)" theme="form" :disabled="disabled"></sp-table>
        <sp-table v-else-if="question.response_type == '34'" type="18" v-model="response.content" :selected="question.response.content" :label="question.content" :required="Boolean(question.required)" theme="form" :disabled="disabled"></sp-table>

      </div>

    </div>
    <sp-tips :tips="question.tips" class="w-full lg:w-1/2 px-4 py-2"></sp-tips>
  </div>

  </div>
</template>

<script>
import Input from "../spKit/Input.vue";
import Textarea from "../spKit/Textarea.vue";
import Checkbox from "../spKit/Checkbox.vue";
import Radio from "../spKit/Radio.vue";
import YoutubeVue from "../spKit/Youtube.vue";
import DropZoneVue from "../spKit/DropZone.vue";
import UrlVue from "../spKit/Url.vue";
import { API_URL } from "@/common/config";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
const uploadURL = API_URL + "/documents/upload";
 import Tips from "@/components/spKit/Tips.vue";
import { mapState } from "vuex";
import SelectVue from '../spKit/Select.vue';
import TableVue from '../spKit/Table.vue';
import TableListVue from '../spKit/Table-list.vue';
export default {
  name: "hide-q-form",
  data() {
    return {
      url: uploadURL,
      response: {
        id: this.question.id,
        content: ""
      },
      invalidfield: false,
      errorMessage: ""
    };
  },
  components: {
    "sp-input": Input,
    "sp-textarea": Textarea,
    "sp-checkbox": Checkbox,
    "sp-radio": Radio,
    "sp-dropzone": DropZoneVue,
    "sp-youtube": YoutubeVue,
    "sp-url": UrlVue,
    "flat-picker": flatPickr,
    "sp-tips": Tips,
    "sp-select": SelectVue,
    "sp-table": TableVue,
    "sp-table-list": TableListVue
  },
  props: {
    index: Number,
    question: {
      required: true,
      type: Object,
      default: null
    },
    responses: {
      required: true,
      type: Array,
      default: null
    },
    disabled:{
      required: false,
      type: Boolean,
      default: false
    },
    showError:{
        required: false,
        type: Boolean,
        default: false
    },
    requestForm:{
      required:false,
      type: Boolean,
      default: false
    }
  },
  methods: {
    updateDisabled(status) {
        this.$emit('update-disabled', status)
      },
    vdropzoneProcessing(file){
        this.updateDisabled(true);
    },
    dropzoneSuccess(file, response) {
      if (!(this.response.content instanceof Array)) {
        this.response.content = [];
      }
      this.response.content.push(response.data.document.id);
      this.responses[this.index] = this.response;
      this.updateDisabled(false);
    },
    vdropzoneError(file, message) {
      this.updateDisabled(false);
      if (message.meta && message.meta.status == 400) this.response.content.splice(-1, 1);
      this.$el.getElementsByClassName("dz-error-message")[0].innerHTML =
        "you cant upload this file";

    },
    vdropzoneRemovedFile(file, error, xhr) {
      if (typeof file.xhrt !== "undefined") {
        let data = JSON.parse(file.xhr.response);
        if (data.meta.status == 200) {
          let index = this.response.content.indexOf(data.data.document.id);
          if (index > -1) {
            this.response.content.splice(index, 1);
          }
        }
      } else {
        let index = this.response.content
          .map(function(x) {
            return x;
          })
          .indexOf(file.id);
        if (index > -1) {
          this.response.content.splice(index, 1);
        }
      }
    },
    onYoutubeUpdate(newUrl) {
      this.response.content = newUrl;
    }
  },
  created() {
    if (
      this.question.response != null &&
      this.question.response.content != null &&
      this.question.response.content != ""
    ) {
      this.response = {
        id: this.question.id,
        content: this.question.response.content
      };
    }
    if (
      this.question.response_type == "2" ||
      this.question.response_type == "3" ||
      this.question.response_type == "16"
    ) {
      this.response.content = [];
    } else if (this.question.response_type == "7") {
      if (this.question.response == null || this.question.response.content == null || this.question.response.content == "") {
        this.response.content = [];
      } else {
        this.response.content == this.question.response.content;
      }
    }

    this.responses.push(this.response);
  },
  mounted() {
    
    if (
      this.question.response != null &&
      'validation' in this.question.response &&
      this.question.response.validations.length > 0
    ) {
      this.errorMessage = this.question.response.validations[0]["message"];
      this.invalidfield = true;
    } else {
      this.invalidfield = false;
      this.errorMessage = "";
    }
  },
  computed: {
    ...mapState({
      errors: state => state.session.errors
    })
  },
  watch: {
    question: function(val) {
      if (
        val.response != null &&
        this.showError &&
        val.response.validations &&
        val.response.validations.length > 0
      ) {
        this.invalidfield = true;
        this.errorMessage = val.response.validations[0]["message"];
      } else {
        this.invalidfield = false;
        this.errorMessage = "";
      }
      if (this.question.response_type == "7") {
          if (this.question.response == null || this.question.response.content == null || this.question.response.content == "") {
            this.response.content = [];
          }
          else {
            this.response.content == this.question.response.content;
          }

      }
    },
    showError(){
          if(this.showError){
               if (
                this.question.response != null &&
                this.question.response.validations!=null &&
                this.question.response.validations.length > 0 &&
                this.showError
              ) {
                this.invalidfield = true;
                this.errorMessage = this.question.response.validations[0]["message"];
              } else {
                this.invalidfield = false;
                this.errorMessage = "";
              }
          }
      }
  }
};
</script>
